export default "__VITE_ASSET__Bq1g0mHM__"